import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

interface Blip {
  x: number;
  y: number;
  id: number;
  big: boolean;
  label?: string;
}

function RadarDot() {
  const [blips, setBlips] = useState<Blip[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const isBig = Math.random() < 0.3; // 30% chance to be a big blip
      const label = isBig ? randomLabel() : undefined; // Only big blips get a label

      const newBlip = {
        x: Math.random() * 80 + 10,
        y: Math.random() * 80 + 10,
        id: Math.random(),
        big: isBig,
        label: label,
      };
      setBlips((prev) => [...prev, newBlip].slice(-5)); // Keep max 5 blips
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  function randomLabel() {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return (
      letters[Math.floor(Math.random() * letters.length)] +
      letters[Math.floor(Math.random() * letters.length)]
    );
  }

  return (
    <div className="relative w-24 h-24 rounded-full overflow-hidden border-2 border-blue-500 shadow-blue-500/50 shadow-md">
      <img src="/images/chart-plot-1.png" alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/30" />

      {/* Radar Sweep */}
      <motion.div
        className="absolute left-1/2 top-1/2 w-0.5 h-full bg-green-400/50 origin-top"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 5, ease: "linear" }}
      />

      {/* Blips */}
      {blips.map((blip) => (
        <React.Fragment key={blip.id}>
          <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 0 }}
            transition={{ duration: 4 }}
            className={`absolute rounded-full ${blip.big ? "w-3 h-3 bg-yellow-400" : "w-2 h-2 bg-red-400"}`}
            style={{
              left: `${blip.x}%`,
              top: `${blip.y}%`,
              transform: "translate(-50%, -50%)",
            }}
          />
          {blip.label && (
            <motion.div
              initial={{ opacity: 1 }}
              animate={{ opacity: 0 }}
              transition={{ duration: 4 }}
              className="absolute text-sm text-white font-semibold drop-shadow-md"
              style={{
                left: `${blip.x + 3}%`,
                top: `${blip.y - 3}%`,
                transform: "translate(-50%, -50%)",
              }}
            >
              {blip.label}
            </motion.div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default RadarDot;
